export default __webpack_public_path__ + "static/media/b60c62a3ad7e12b124b009f39948951a1579624493803.22ebb096.webp";